import React, { FC, useState } from 'react';
import {
  KeyboardAvoidingView,
  View,
  Text,
  TextInput as NativeTextInput,
  Platform,
  TextInputProps,
  Image,
} from 'react-native';

export type TextInputBaseProps = {
  blurInputContainerStyle?: any;
  containerStyle?: any;
  disabledContainerStyle?: any;
  disabledTextInputStyle?: any;
  editable?: boolean;
  errorInputContainerStyle?: any;
  errorMessage?: string | boolean;
  errorMessageTextStyle?: any;
  focusInputContainerStyle?: any;
  imageKey?: string;
  imageStyle?: any;
  invalidCharacters?: any;
  label?: string;
  labelHidden?: boolean;
  labelStyle?: any;
  onBlur?: Function;
  textInputStyle?: any;
};

export type InputProps = TextInputBaseProps & TextInputProps;
const TextInputBase: FC<InputProps> = (props) => {
  const BLUR = 'blur';
  const FOCUS = 'focus';
  const [inputAction, setInputAction] = useState('');
  const {
    autoCapitalize = 'none',
    autoCompleteType,
    autoCorrect = false,
    blurInputContainerStyle,
    containerStyle,
    disabledContainerStyle,
    disabledTextInputStyle,
    editable = true,
    errorInputContainerStyle,
    errorMessage,
    errorMessageTextStyle,
    focusInputContainerStyle,
    imageKey,
    imageStyle,
    invalidCharacters = '',
    keyboardType,
    label,
    labelHidden,
    labelStyle,
    multiline,
    numberOfLines,
    placeholder,
    onBlur,
    onChangeText,
    onFocus,
    onKeyPress,
    onSubmitEditing,
    onSelectionChange,
    secureTextEntry,
    textContentType,
    textInputStyle,
    value,
  } = props;

  const localOnChangeText = (prevValue) => {
    if (!editable) {
      return;
    }
    const value = invalidCharacters.split('').reduce((result, character) => {
      return result.replace(character, '');
    }, prevValue);
    onChangeText && onChangeText(value);
  };

  const localOnBlur = (e) => {
    setInputAction(BLUR);
    onBlur && onBlur(e);
  };

  const localOnFocus = (e) => {
    setInputAction(FOCUS);
    onFocus && onFocus(e);
  };

  const getInputContainerStyle = () => {
    let inputContainerStyle = blurInputContainerStyle;
    if (!editable) {
      inputContainerStyle = disabledContainerStyle;
    } else if (inputAction === BLUR) {
      inputContainerStyle = blurInputContainerStyle;
    } else if (inputAction === FOCUS) {
      inputContainerStyle = focusInputContainerStyle;
    }

    if (errorMessage) {
      inputContainerStyle = errorInputContainerStyle;
    }

    return inputContainerStyle;
  };

  const getTextInputStyle = () => {
    return editable ? textInputStyle : disabledTextInputStyle;
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS == 'ios' ? 'padding' : 'height'}
      // style={styles.container}
    >
      <View style={containerStyle}>
        {!labelHidden && <Text style={labelStyle}>{label}</Text>}
        <View style={getInputContainerStyle()}>
          {imageKey && (
            <Image
              source={require(`./assets/${imageKey}.svg`)}
              style={imageStyle}
            />
          )}
          <NativeTextInput
            autoCorrect={autoCorrect}
            autoCapitalize={autoCapitalize}
            autoCompleteType={autoCompleteType}
            accessibilityLabel={label?.toLowerCase()}
            editable={editable}
            keyboardType={keyboardType}
            multiline={multiline}
            numberOfLines={numberOfLines}
            placeholder={placeholder}
            onBlur={(e) => localOnBlur(e)}
            onFocus={(e) => localOnFocus(e)}
            onChangeText={localOnChangeText}
            onKeyPress={onKeyPress}
            onSubmitEditing={onSubmitEditing}
            onSelectionChange={onSelectionChange}
            secureTextEntry={secureTextEntry}
            style={getTextInputStyle()}
            textContentType={textContentType}
            value={value}
          />
        </View>
      </View>
      {errorMessage && (
        <Text style={errorMessageTextStyle}>{errorMessage}</Text>
      )}
    </KeyboardAvoidingView>
  );
};

export default TextInputBase;
